/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import {set_page_refresh} from "../../redux/action";
import Select from 'react-select'
import axios from "axios";
import PropTypes from 'prop-types';
import InvoiceDownloader from './InvoiceDownloader'
import { useDispatch, useSelector } from 'react-redux';
import { getCurrencySymbol } from '../../../plugins/helper';


const EditCareSales =({ record,dataStore })=> {
    console.log("storeData2",dataStore);
    const dispatch = useDispatch();
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");
    const choose = t?.[l]?.["choose"] || "Choose";
    const allProducts= useSelector((state) => state.product_list);
    const [productFilterList, setProductFilterList] = useState([])  
    const saleData = record;
    const [sale, setOrder] = useState({})
    const [grossTotal, setGrossTotal] = useState([])
    const [grossCount, setGrossCount] = useState([])
    const [referenceNumber, setReferenceNumber] = useState([])
    const [shipping, setShipping] = useState([])
    const [customDiscount, setCustomDiscount] = useState([])
    const [saleStatus, setOrderStatus] = useState([])
    const [transitStatus, setTransitStatus] = useState([])
    const [paymentType, setPaymentType] = useState([])
    const [departureDate, setDepartureDate] = useState("")
    const closeRef = useRef(null)

    const [manualPayments, setManualPayments] = useState([]);
    const [addiPayment, setAddiPayment] = useState(0);
    // const [totalPaid, setTotalPaid] = useState(0);
    const [error, setError] = useState('');
    const [manualAmount, setManualAmount] = useState('');
    const [manualDate, setManualDate] = useState(new Date().toISOString().split('T')[0]);

    const [comments, setComments] = useState('');


    const status = [
        { value: 'choose', label: choose },
        { value: 'pending', label: t?.[l]?.["pending"] || 'Pending' },
        { value: 'received', label: t?.[l]?.["received"] || 'Received' },
        { value: 'returned', label: t?.[l]?.["returned"] || 'Returned' },
    ];
    const orderStatus = [
        { value: 'choose', label: choose },
        { value: 'Packing', label: t?.[l]?.["packing"] || 'Packing' },
        { value: 'ConfirmOrder', label: t?.[l]?.["confirm_order"] || 'Confirm Order' },
    ];
    const handleDelete = (index) => {
        const updatedPayments = [...manualPayments];
        updatedPayments.splice(index, 1);
        setManualPayments(updatedPayments); // Assuming you're using useState
    };

    if (record?.deliveryType === 'pickup') {
        orderStatus.push({ value: 'Pickup', label: t?.[l]?.["pickup"] || 'Pickup' });
        orderStatus.push({ value: 'Delivered', label: t?.[l]?.["delivered"] || 'Delivered' });
    } else {
        orderStatus.push({ value: 'Shipped', label: t?.[l]?.["shipped"] || 'Shipped' });
        orderStatus.push({ value: 'Delivered', label: t?.[l]?.["delivered"] || 'Delivered' });
    }
    orderStatus.push({ value: 'Refunded', label: t?.[l]?.["refunded"] || 'Refunded' });
    const paymentTypes = [
      { value: 'choose', label: choose },
    { value: 'COD', label: record?.deliveryType == 'pickup' 
        ? t?.[l]?.["cash_on_pickup"] || 'Cash On Pickup'  // If status is 'Pickup', use 'Cash On Pickup'
        : t?.[l]?.["cash_on_delivery"] || 'Cash On Delivery'},

      { value: 'BANKTRANSFER', label: t?.[l]?.["bank_reciept"] || 'Bank Reciept' },
      { value: 'Stripe', label: t?.[l]?.["stripe"] || 'Stripe' },
    ];
    // useEffect(() => {
    //     const manualSum = manualPayments.reduce((sum, p) => sum + Number(p.amount), 0);
    //    // const total = manualSum + Number(addiPayment || 0);
    //     // setTotalPaid(manualSum);
    //     //setAddiPayment(manualSum);
    // }, [manualPayments]);
    useEffect(() => {
        let p2 = sale.products
        console.log('p2', p2);
        let gC = p2?.reduce((a, s) => a + Number(s.quantity), 0) || 0
        let gT = p2?.reduce((a, s) => a + s.totalCost, 0) || 0
        let shippingCost = record?.shippingCost?record?.shippingCost:0;
        let grossTotal = gT+Number(shippingCost);//record?.grossTotal?record?.grossTotal:0;

        setGrossTotal(grossTotal - Number(customDiscount?customDiscount:0))
        setShipping(shippingCost);
        setGrossCount(gC)
        setReferenceNumber(sale.referenceNumber)
    }, [sale, productFilterList, customDiscount])

    useEffect(() => {
        if (saleData ) {
            let data = JSON.parse(JSON.stringify(saleData)) || {};
    
            if (typeof data.products === "string") {
                try {
                    data.products = JSON.parse(data.products);
                } catch (error) {
                    console.error("Error parsing products:", error);
                    data.products = [];  // Set a default empty array if parsing fails
                }
            }
        if (!Array.isArray(data.products)) {
                console.warn("`data.products` is not an array, resetting to an empty array.");
                data.products = [];
            }
            if(data && Object.keys(data)){
                Object.keys(data).forEach((k) => {
                    setOrder((prevState) => ({ ...prevState, [k]: data[k] }));
                });
            }
    
            setOrderStatus(data.saleStatus || "");
            setPaymentType(data.paymentType || "");
            setTransitStatus(data.transitStatus || "");
            setCustomDiscount(data.customDiscount || 0);

            setManualPayments(data.manualPayments || []);
            setAddiPayment(data.addiPayment || 0);
           // setTotalPaid(data.totalPaid || 0);
        }
    
        setProductFilterList(allProducts || []); 
    }, [saleData, allProducts]);
    

    const addManualPayment = (event) => {
        event.preventDefault()
        event.stopPropagation()
        const total =
        manualPayments.reduce((sum, item) => sum + item.amount, 0)

        if (total > grossTotal) {
        setError('Total payments exceed total cost.');
        return;
        }

        setManualPayments((prev) => [
        ...prev,
        { amount: Number(manualAmount), date: manualDate,addiPayment: Number(addiPayment), comments: comments  }
        ]);
        ////comments,addiPayment,manualAmount
        setError('');
        setManualAmount('');
        setAddiPayment(0);
        setComments('');
    };


    const submit= async (event) => {
        const form = event.currentTarget;
        event.preventDefault()
        event.stopPropagation()
        try {
        if(form?.checkValidity() && sale?.products.length) {
            console.log("manualPayments",manualPayments)
            const totalPaid = manualPayments.reduce((sum, item) => sum + item.amount, 0);
            const tAddiPayment = manualPayments.reduce((sum, item) => sum + item.addiPayment, 0);
            console.log("totalPaid",totalPaid)
            console.log("tAddiPayment",tAddiPayment)
            await axios.post('addupdateorder/', {_id: sale?._id, grossCount, grossTotal, 
                customDiscount, saleStatus, paymentType, transitStatus,
                 products: sale.products,
                 manualPayments,totalPaid,tAddiPayment, departureDate});
            dispatch(set_page_refresh("saleslist"))
            closeRef.current?.click()
            document.querySelector(".modal-backdrop").classList.toggle("show")
        
        }
        } catch(e) {
            if(e?.response?.status && e?.response?.data?.message) {
                React.toast.error(e.response?.data.message)
            }
            return false;
        }
        

        return false;
    }
  
    return (
        <div>
            {/* Add Order */}
            <div className="modal fade" id="add-units">
                <div className="modal-dialog purchase modal-dialog-centered stock-adjust-modal">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>{Object.keys(saleData || {}).length > 0 ? t?.[l]?.["edit_order"] ||  "Edit Order" : t?.[l]?.["edit_order"] ||  "Edit Order"}</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        ref={closeRef}
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form>
                                        <div className="row">
                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>{t?.[l]?.["customer_name"] || "Customer Name"}</label>
                                                    <input type="text" disabled className="form-control"  name="name" value={sale?.shippingAddress?.name || ""}/>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>{t?.[l]?.["email_address"] || "Email Address"}</label>
                                                    <input type="text" disabled className="form-control" name="email" value={sale.shippingAddress?.email || ""}/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>{t?.[l]?.["phone_number"] || "Phone Number"}</label>
                                                    <input type="text" disabled className="form-control" name="contactNo" value={sale.shippingAddress?.contactNo|| ""}/>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12">
                                            {sale.deliveryType === "pickup" ? (
                                                <div className="input-blocks">
                                                    <label>{t?.[l]?.["pickup_address"] || "Pickup Address"}</label>
                                                    <input
                                                    type="text"
                                                    disabled
                                                    className="form-control"
                                                    name="address"
                                                    value={sale?.pickupStoreAddress || ""}
                                                    />
                                                </div>
                                                ) : (
                                                <div className="input-blocks">
                                                    <label>{t?.[l]?.["shipping_address"] || "Shipping Address"}</label>
                                                    <input
                                                    type="text"
                                                    disabled
                                                    className="form-control"
                                                    name="address"
                                                    value={
                                                        (sale.shippingAddress?.address
                                                        ? sale.shippingAddress.address + ", "
                                                        : "") +
                                                        (sale.shippingAddress?.area ? sale.shippingAddress.area + ", " : "") +
                                                        (sale.shippingAddress?.country || "")
                                                    }
                                                    />
                                                </div>
                                                )}

                                            </div>
                                        </div>
                                        
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="modal-body-table">
                                                    <div className="table-responsive">
                                                        <table className="table">
                                                            <thead>
                                                                <tr>
                                                                    <th></th>
                                                                    <th>{t?.[l]?.["product"] || "Product"}</th>
                                                                    <th>{t?.[l]?.["chassis_number"] || "Chassis Number"}</th>
                                                                    <th>{t?.[l]?.["description"] || "Description"}</th>
                                                                    
                                                                    <th>{t?.[l]?.["unit_cost"] || "Unit Cost"}</th>
                                                                    <th>{t?.[l]?.["discount"] || "Discount"}</th>
                                                                    <th>{t?.[l]?.["total"] || "Total"}</th>
                                                                    <th>{t?.[l]?.["paid"] || "Paid"}</th>
                                                                    <th>{t?.[l]?.["balance"] || "Balance"}</th>
                                                                    <th>{t?.[l]?.["others"] || "Others"}</th>
                                                                    <th>Download</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {sale?.products?.map((p, i) => {
                                                                    return (
                                                                        <tr key={i}>
                                                                            <td>{i + 1}</td>
                                                                            <td className="">{p?.name}</td>
                                                                            <td className="">{p?.chassisNumber}</td>
                                                                            <td className="">
                                                                                {p?.customizedData && Object.keys(p.customizedData).length > 0 ? (
                                                                                    t?.[l]?.["customized"] || "Customized"
                                                                                ) : (
                                                                                    p?.attributeValue && Object.keys(p.attributeValue).length > 0 ? 
                                                                                        Object.values(p.attributeValue).join(" | ") : 
                                                                                        (t?.[l]?.["not_specified"] || "Not Specified")
                                                                                )}
                                                                            </td>
                                                                            <td className="">{`${getCurrencySymbol()}${(Number(p?.unitPrice) || 0).toLocaleString()}`}</td>
                                                                            <td className="">{p?.discountValue + (p.discountType == "percentage" ? " (%)" : "")}</td>
                                                                            <td className="">{`${getCurrencySymbol()}${(p?.totalCost || 0).toLocaleString()}`}</td>
                                                                            <td className="">{`${getCurrencySymbol()}${(sale?.totalPaid || 0).toLocaleString()}`}</td>
                                                                            <td className="">{`${getCurrencySymbol()}${(Number(p.totalCost || 0) - Number(sale?.totalPaid || 0)).toLocaleString()}`}</td>
                                                                            <td className="">{`${getCurrencySymbol()}${(sale?.tAddiPayment || 0).toLocaleString()}`}</td>
                                                                            <td>
                                                                                <InvoiceDownloader data={{
                                                                                    manualPayments,
                                                                                    addiPayment: addiPayment,
                                                                                    totalPaid: manualPayments.reduce((sum, item) => sum + item.amount, 0) + Number(addiPayment),
                                                                                    totalCost: grossTotal,
                                                                                    orderInfo: record,
                                                                                    dataStore: dataStore
                                                                                }} />
                                                                            </td>
                                                                 
                                                                        </tr>
                                                                    )
                                                                })}
                                                                
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                           
                                            <div className="row">
                                                <div className="col-lg-2 col-md-6 col-sm-12">
                                                    <div className="input-blocks">
                                                        <label>{t?.[l]?.["payment_type"] || "Payment Type"}</label>
                                                        <Select options={paymentTypes} required className="select" placeholder={choose} 
                                                        
                                                        value = {
                                                            paymentTypes?.filter(option => 
                                                            option?.value === paymentType)
                                                        }
                                                        onChange={(v) => {
                                                            setPaymentType(v.value)
                                                        }} />
                                                    </div>
                                                </div>
                                               
                                                <div className="col-lg-2 col-md-6 col-sm-12">
                                                    <div className="input-blocks">
                                                        <label>{t?.[l]?.["payment_status"] || "Payment Status"}</label>
                                                        <Select options={status} required className="select" placeholder={choose} 
                                                        
                                                        value = {
                                                            status?.filter(option => 
                                                            option?.value === saleStatus)
                                                        }
                                                        onChange={(v) => {
                                                            setOrderStatus(v.value)
                                                        }} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-md-6 col-sm-12">
                                                    <div className="input-blocks">
                                                        <label>{t?.[l]?.["order_status"] || "Order Status"}</label>
                                                        <Select options={orderStatus} required className="select" placeholder={choose}    
                                                            value = {
                                                                orderStatus?.filter(option => 
                                                                option?.value === transitStatus)
                                                            }
                                                            onChange={(v) => {
                                                                setTransitStatus(v.value)
                                                            }} 
                                                        />
                                                    </div>
                                                </div>
                                                 <div className="col-lg-2 col-md-6 col-sm-12">
                                                    <div className="input-blocks">                         
                                                        <label>{t?.[l]?.["departure_date"] || "Departure Date"}</label>
                                                        <input
                                                        type="date"
                                                        className="form-control"
                                                        name="departureDate"
                                                        value={departureDate}
                                                        min={new Date()}
                                                        onChange={(v) => {
                                                            console.log("departureDate", v.target.value)
                                                            setDepartureDate(v.target.value)
                                                        }}
                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="col-lg-1 col-md-1 col-sm-12">
                                                 
                                                </div> */}
                                                <div className="col-lg-3 col-md-3 col-sm-12">
                                                    <div className="input-blocks">
                                                    <label>{t?.[l]?.["discount"] || "Discount"}</label>
                                                    <input type="text" className="form-control" value={customDiscount} onChange={(e) => {
                                                            setCustomDiscount(Number(e.target.value) || 0)
                                                        }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className={`col-lg-3 col-md-3 col-sm-12 ${paymentType == 'COD' ? "invisible" : ""}`}>
                                                    <div className="input-blocks">
                                                        <label>{t?.[l]?.["reciept_id"] || "Reciept ID" }</label>
                                                        <input type="text" className="form-control" name="referenceNumber" disabled  value={referenceNumber} />
                                                    </div>
                                                </div>
                                                <div className={`col-lg-6 col-md-6 col-sm-12 ${paymentType == 'BankReciept' ? "" : "invisible"}`}>
                                                    <div className="input-blocks">
                                                    </div>
                                                </div>
                                                   
                                                <div className="ccol-lg-2 col-md-2 col-sm-12">
                                                    <div className="input-blocks">
                                                        {/* <label>{t?.[l]?.["item_count"] || "Item Count"}</label> */}
                                                        <label>{t?.[l]?.["shipping"] || "Shipping"}</label>
                                                        <label>{t?.[l]?.["gross_total"] || "Gross Total"}</label>

                                                    </div>
                                                </div>
                                                <div className="col-lg-1 col-md-1 col-sm-12">
                                                    <div className="input-blocks">
                                                        {/* <label>{grossCount}</label> */}
                                                        <label>{shipping}</label>
                                                        <label>{grossTotal}</label>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <h4>Add Manual Payment</h4>
                                            <hr/>
                                            <div className="col-lg-2 col-md-2 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>{t?.[l]?.['date'] || 'Date'}</label>
                                                    <input type="date" className="form-control" name="manualDate" value={manualDate} onChange={(e) => setManualDate(e.target.value)} />
                                                </div>
                                            </div>
                                            
                                            <div className="col-lg-2 col-md-2 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>{t?.[l]?.['amount'] || 'Amount'}</label>
                                                    <input
                                                    type="text"
                                                    className="form-control"
                                                    name="manualAmount"
                                                    value={manualAmount}
                                                    maxLength="8"
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*$/.test(value)) {
                                                        setManualAmount(value);
                                                        }
                                                    }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-2 col-md-2 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>{t?.[l]?.['additional_amount'] || 'Additional Amount'}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="addiPayment"
                                                        value={addiPayment}
                                                        maxLength="8"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d*$/.test(value)) {
                                                            setAddiPayment(value);
                                                            }
                                                        }}
                                                        
                                                    />
                                                </div>
                                            </div>
                                            

                                            <div className="col-lg-3 col-md-3 col-sm-12">
                                                <div className="input-blocks">
                                                   <label>{t?.[l]?.['comments'] || 'Comments'}</label>
                                                    <input
                                                    type="text"
                                                    className="form-control"
                                                    name="comments"
                                                    value={comments}
                                                    maxLength="150"
                                                    onChange={(e) => setComments(e.target.value)}
                                                    /> 
                                                </div>
                                            </div>
                                            
                                            <div className="col-lg-3 col-md-3 col-sm-12">
                                                <div className="input-blocks">
                                                     <label> &nbsp;</label>
                                                   <button className="btn btn-primary form-control" onClick={addManualPayment}>{t?.[l]?.['add'] || 'Add'}</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                             <h4>Transactions</h4>
                                             <hr />
                                            <div className="col-lg-12">
                                                <div className="modal-body-table">
                                                    <div className="table-responsive">
                                                    {manualPayments.length === 0 && <p>No manual payments added yet.</p>}
                                                        {manualPayments.length>0 &&  
                                                            <table className="table">
                                                                <thead>
                                                                <tr>
                                                                <th>#</th>
                                                                <th>Date</th>
                                                                <th>Amount</th>
                                                                <th>Other Amount</th>
                                                                <th>Comments</th>
                                                                <th>Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {manualPayments.map((p, idx) => (
                                                                <tr key={idx}>
                                                                    <td>{idx + 1}</td>
                                                                    <td><i>{p.date}</i></td>
                                                                    <td><b>{`${getCurrencySymbol()}${(p.amount || 0).toLocaleString()}`}</b></td>
                                                                    <td><b>{`${getCurrencySymbol()}${(p.addiPayment || 0).toLocaleString()}`}</b></td>
                                                                    <td><b>{p.comments}</b></td>
                                                                    <td>
                                                                        <button
                                                                            className="btn btn-danger btn-sm"
                                                                            onClick={() => handleDelete(idx)}
                                                                        >
                                                                            Delete
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                ))}
                                                            </tbody>
                                                            </table>
                                                        }
                                                    {error && <div className="text-danger">{error}</div>} 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        

                                        <div className="col-lg-12">
                                            <div className="modal-footer-btn">
                                                <button
                                                    type="button"
                                                    className="btn btn-cancel me-2"
                                                    data-bs-dismiss="modal"
                                                >
                                                    {t?.[l]?.["cancel"] || "Cancel"}
                                                </button>
                                                
                                                {/* <button type="submit" className="btn btn-submit">
                                                    {t?.[l]?.["save"] || "Save"}
                                                </button> */}
                                                  <button onClick={submit} className="btn btn-submit">
                                                    {t?.[l]?.["save"] || "Save"}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
EditCareSales.propTypes = {
    record: PropTypes.object,
    dataStore: PropTypes.array
};
export default EditCareSales